import Accordion from "@/common/components/Accordion";
import { BookMarked } from "lucide-react";

export default function AccordionMaintenanceWorkflowSchedulesOverview() {
  return (
    <Accordion
      name="maintenanceWorkflowSchedulesOverview"
      head={
        <div className="flex items-center gap-1">
          <BookMarked strokeWidth={1.5} />
          <p className="text-base">Como funciona a programação de manutenção</p>
        </div>
      }
      body={
        <div className="flex flex-col gap-4">
          <p className="text-sm">
            Programa de Manutenção permite que o gestor de frotas crie regras automáticas para gerar solicitações de manutenção com base em critérios personalizados. É possível agrupar equipamentos por odômetro, filial, categoria, fabricante e outros filtros, além de definir as condições que acionam a execução do programação — como atingir determinada quilometragem, tempo de uso ou intervalo desde a última manutenção.
          </p>
          <p className="text-sm">
            Quando um equipamento atender às condições definidas, o sistema gera automaticamente uma Solicitação de Manutenção e notifica o responsável, com avisos por e-mail e na dashboard. Isso garante mais controle, reduz falhas inesperadas e facilita o planejamento da manutenção preventiva da frota.
          </p>
        </div>
      }
    />
  )
}
